var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarNav8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-tabs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6666 15.5001C12.3297 15.5001 12.9656 15.7635 13.4344 16.2323C13.9032 16.7012 14.1666 17.337 14.1666 18.0001C14.1666 18.6631 13.9032 19.299 13.4344 19.7678C12.9656 20.2367 12.3297 20.5001 11.6666 20.5001V22.1667C11.6666 22.6088 11.8422 23.0327 12.1548 23.3453C12.4673 23.6578 12.8913 23.8334 13.3333 23.8334H26.6666C27.1087 23.8334 27.5326 23.6578 27.8451 23.3453C28.1577 23.0327 28.3333 22.6088 28.3333 22.1667V20.5001C27.6703 20.5001 27.0344 20.2367 26.5655 19.7678C26.0967 19.299 25.8333 18.6631 25.8333 18.0001C25.8333 17.337 26.0967 16.7012 26.5655 16.2323C27.0344 15.7635 27.6703 15.5001 28.3333 15.5001V13.8334C28.3333 13.3914 28.1577 12.9675 27.8451 12.6549C27.5326 12.3423 27.1087 12.1667 26.6666 12.1667H13.3333C12.8913 12.1667 12.4673 12.3423 12.1548 12.6549C11.8422 12.9675 11.6666 13.3914 11.6666 13.8334V15.5001Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 17.9999L19.1667 19.6666L22.5 16.3333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNav8);
export default __webpack_public_path__ + "static/media/sidebar-nav-8.ee7de33e9d2e79933c83c5774d355319.svg";
export { ForwardRef as ReactComponent };